// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Generic table styles */
.virtual-table {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.virtual-table .table-container-wrapper {
  width: 100%;
  flex: 1 1 auto;

  /* The table won't shrink properly without this */
  height: calc(100% - 50px);
}

.virtual-table .public_fixedDataTable_bodyRow a i:hover {
  cursor: pointer;
}

.virtual-table .fixedDataTableLayout_main {
  background-color: rgba(250, 250, 250, 0.8);
}

.virtual-table .fixedDataTableLayout_main:focus {
  outline: inherit;
}

/* Common cell content styles */

.virtual-table .cell-wrapper {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  max-height: 50px;
  padding: 5px;
}

.virtual-table .cell-wrapper .plain.cell,
.virtual-table .cell-wrapper .empty.dropdown {
  margin: 0px 3px;
}

.virtual-table .cell-wrapper .ui.progress .bar {
  height: 5px;
}

/* Footer */

.table-footer {
  width: 100%;
  padding: 5px;
  background-color: #f6f7f8;
  background-image: -webkit-linear-gradient(#fff, #efefef);
  background-image: linear-gradient(#fff, #efefef);
  display: flex;
  align-items: center;
}

.table-footer > .filter {
  margin-left: auto;
  display: flex;
}

.table-footer > .filter > .count-info {
  margin-right: 0px;
  opacity: 0.6;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.table-footer > .filter > div:last-child {
  margin-left: 10px;
}

.table-footer > .filter .filter-method.dropdown.button {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.table-footer > .filter .dropdown .trigger.icon {
  margin-right: 0px;
}

.table-footer > .filter input {
  width: 90%;
}

/* Table dropdowns */
.table-container-wrapper .dropdown > .popup.trigger {
  max-width: 100%;

  line-height: 21px;
  display: flex;
  align-items: flex-start;
}

.table-container-wrapper .dropdown > .popup.trigger .caption {
  max-width: calc(100% - 20px);
}

.table-container-wrapper .dropdown > .popup.trigger .caption > * {
  overflow: hidden;
}

.table-container-wrapper .dropdown > .popup.trigger:hover,
.public_fixedDataTableCell_main a:hover {
  cursor: pointer;
}

.table-container-wrapper .dropdown > .popup.trigger:hover span,
.public_fixedDataTableCell_main a:hover {
  text-decoration: underline;
}

.table-container-wrapper .dropdown > .popup.trigger i.angle.icon {
  margin: 0px;
}

.table-container-wrapper .empty.dropdown.filtered:not(.no-access) > div {
  padding-left: 22px;
}

.table-container-wrapper .dropdown .trigger i {
  flex-shrink: 0;
}

/* Table dropdown popup content */
.popup.dropdown-content {
  padding: 5px 15px;
  overflow: hidden;
}

.popup.dropdown-content .ui.dropdown.item {
  margin: 0px 0px;
}

.virtual-table .public_fixedDataTable_header .button.link,
.public_fixedDataTableCell_main .button.link {
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/table/style.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;;EAEd,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wDAAwD;EACxD,gDAAgD;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,eAAe;;EAEf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":["/* Generic table styles */\r\n.virtual-table {\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.virtual-table .table-container-wrapper {\r\n  width: 100%;\r\n  flex: 1 1 auto;\r\n\r\n  /* The table won't shrink properly without this */\r\n  height: calc(100% - 50px);\r\n}\r\n\r\n.virtual-table .public_fixedDataTable_bodyRow a i:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.virtual-table .fixedDataTableLayout_main {\r\n  background-color: rgba(250, 250, 250, 0.8);\r\n}\r\n\r\n.virtual-table .fixedDataTableLayout_main:focus {\r\n  outline: inherit;\r\n}\r\n\r\n/* Common cell content styles */\r\n\r\n.virtual-table .cell-wrapper {\r\n  position: relative;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  max-height: 50px;\r\n  padding: 5px;\r\n}\r\n\r\n.virtual-table .cell-wrapper .plain.cell,\r\n.virtual-table .cell-wrapper .empty.dropdown {\r\n  margin: 0px 3px;\r\n}\r\n\r\n.virtual-table .cell-wrapper .ui.progress .bar {\r\n  height: 5px;\r\n}\r\n\r\n/* Footer */\r\n\r\n.table-footer {\r\n  width: 100%;\r\n  padding: 5px;\r\n  background-color: #f6f7f8;\r\n  background-image: -webkit-linear-gradient(#fff, #efefef);\r\n  background-image: linear-gradient(#fff, #efefef);\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.table-footer > .filter {\r\n  margin-left: auto;\r\n  display: flex;\r\n}\r\n\r\n.table-footer > .filter > .count-info {\r\n  margin-right: 0px;\r\n  opacity: 0.6;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.table-footer > .filter > div:last-child {\r\n  margin-left: 10px;\r\n}\r\n\r\n.table-footer > .filter .filter-method.dropdown.button {\r\n  padding-left: 0px !important;\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.table-footer > .filter .dropdown .trigger.icon {\r\n  margin-right: 0px;\r\n}\r\n\r\n.table-footer > .filter input {\r\n  width: 90%;\r\n}\r\n\r\n/* Table dropdowns */\r\n.table-container-wrapper .dropdown > .popup.trigger {\r\n  max-width: 100%;\r\n\r\n  line-height: 21px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.table-container-wrapper .dropdown > .popup.trigger .caption {\r\n  max-width: calc(100% - 20px);\r\n}\r\n\r\n.table-container-wrapper .dropdown > .popup.trigger .caption > * {\r\n  overflow: hidden;\r\n}\r\n\r\n.table-container-wrapper .dropdown > .popup.trigger:hover,\r\n.public_fixedDataTableCell_main a:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.table-container-wrapper .dropdown > .popup.trigger:hover span,\r\n.public_fixedDataTableCell_main a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.table-container-wrapper .dropdown > .popup.trigger i.angle.icon {\r\n  margin: 0px;\r\n}\r\n\r\n.table-container-wrapper .empty.dropdown.filtered:not(.no-access) > div {\r\n  padding-left: 22px;\r\n}\r\n\r\n.table-container-wrapper .dropdown .trigger i {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Table dropdown popup content */\r\n.popup.dropdown-content {\r\n  padding: 5px 15px;\r\n  overflow: hidden;\r\n}\r\n\r\n.popup.dropdown-content .ui.dropdown.item {\r\n  margin: 0px 0px;\r\n}\r\n\r\n.virtual-table .public_fixedDataTable_header .button.link,\r\n.public_fixedDataTableCell_main .button.link {\r\n  color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
